import {useState} from 'react';
import HeaderPage from '../../components/header_page';
import Selector from '../../../selectors/pages/main/balance';
import {useSelector} from 'react-redux';

import Choose from './choose';
import CashApp from './cashapp';
import CashAppNew from './cashapp_new';
import Bitcoin from './bitcoin';

export default () => {
    const [stage, setStage] = useState('choose'),
          [method, setMethod] = useState(null),
          {wallet} = useSelector(Selector);

    return (
        <>
            <HeaderPage title={"Cash Out"} />

            {stage === "choose" && <Choose cashapp_enabled={wallet.cashapp_enabled} walletId={wallet.id} walletProject={wallet.project} onNext={method => {
                setMethod(method);
                setStage("method");
            }} />}

            {stage === "method" && (
                <>
                    {method === "bitcoin" && <Bitcoin />}
                    {method === "cashapp" && <CashAppNew />}
                </>
            )}
        </>
    )
}